import { defineComponent } from 'vue';
import { prevPageView, closeAppView } from '@/widget';
export default defineComponent({
    name: 'EHeader',
    props: {
        title: {
            type: String,
            default: ''
        },
        btnText: {
            type: String,
            default: '提交'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showBack: {
            type: Boolean,
            default: true
        },
        showBtn: {
            type: Boolean,
            default: true
        },
        showShare: {
            type: Boolean,
            default: false
        },
        bgColor: {
            type: String,
            default: '#ffffff'
        },
        isXue: {
            default: false,
            type: Boolean
        }
    },
    setup(props, context) {
        const goBack = () => {
            if (props.isXue) {
                closeAppView();
            }
            else {
                prevPageView();
            }
        };
        const submit = () => {
            if (!props.disabled) {
                context.emit('submit');
            }
        };
        const shareAction = () => {
            context.emit('share');
        };
        return {
            goBack,
            submit,
            shareAction
        };
    }
});
